import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import './loginModal.css';

interface LoginModalProps {
  onClose: () => void;
  sessionExpired?: boolean;
}

const LoginModal: React.FC<LoginModalProps> = ({ onClose, sessionExpired }) => {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!username || !password) {
      setError('יש למלא שם משתמש וסיסמה');
      return;
    }
    setIsLoading(true);
    setError('');
    const result = await login(username, password);
    setIsLoading(false);
    if (result.success) {
      onClose();
    } else {
      setError(result.error || 'שם משתמש או סיסמה שגויים');
    }
  };

  return (
    <div className="login-overlay" onClick={onClose}>
      <div className="login-modal" onClick={(e) => e.stopPropagation()}>
        <h2 className="login-modal__title">כניסה למערכת</h2>
        {sessionExpired && (
          <p className="login-form__error">פג תוקף החיבור, אנא התחבר שוב</p>
        )}
        <form onSubmit={handleSubmit} className="login-form">
          <div className="login-form__field">
            <label htmlFor="username">שם משתמש</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
            />
          </div>
          <div className="login-form__field">
            <label htmlFor="password">סיסמה</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>
          {error && <p className="login-form__error">{error}</p>}
          <div className="login-form__actions">
            <button type="submit" className="login-btn" disabled={isLoading}>
              {isLoading ? '...' : 'כניסה'}
            </button>
            <button type="button" className="cancel-btn" onClick={onClose}>
              ביטול
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginModal;
